import { fetchApi } from '@/config/axiosSetting';
import { GetAdjusterRankChartQueryResponseType } from './getAdjusterRankChartQuery.type';

export const getAdjusterRankChartFunction =
  (): Promise<GetAdjusterRankChartQueryResponseType> => {
    return fetchApi.get('/survey/rank_trend/');
  };
